import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { getDataFromAPI } from "../../../../HandleAPICalls/actions";
import CohortAssortmentCreationComponent from "./component";
import { useParams, useNavigate } from "react-router-dom";
import debounce from 'lodash/debounce';
import { toastr } from 'react-redux-toastr';

const CohortAssortmentListDetailsContainer = (props) => {
  const navigate = useNavigate();
  const { reference_id } = useParams();
  const [showEndRuleModal, setShowEndRuleModal] = useState(false);
  const [showLinkWarehouseModal, setShowLinkWarehouseModal] = useState(false);
  const [showUnlinkConfirmationModal, setShowUnlinkConfirmationModal] = useState(false);
  const [showUnlinkSuccessModal, setShowUnlinkSuccessModal] = useState(false);
  const [selectedRuleToEnd, setSelectedRuleToEnd] = useState(null);
  const [endDate, setEndDate] = useState("");
  const [loading, setLoading] = useState(true);
  const [assortmentWarehouseMetaDataDetails, setAssortmentWarehouseMetaDataDetails] = useState(null);
  const [assortmentWarehouseMetaDataDetailsList, setAssortmentWarehouseMetaDataDetailsList] = useState({ active: [], scheduled: [], inactive: [] });
  const [assortmentWarehouseMetaDataRuleDetailsList, setAssortmentWarehouseMetaDataRuleDetailsList] = useState({ active: [], scheduled: [], inactive: [] });
  const [assortmentCohortMachinesDetailsList, setAssortmentCohortMachinesDetailsList] = useState();
  const [activeTab, setActiveTab] = useState("assortments");
  const [selectedHardwareType, setSelectedHardwareType] = useState(null);
  const [warehouseList, setWarehouseList] = useState([]);
  const [selectedWarehouse, setSelectedWarehouse] = useState(null);
  const [filteredWarehouses, setFilteredWarehouses] = useState([]);
  const [warehouseSearchTerm, setWarehouseSearchTerm] = useState("");

  // Initialize all data loading functions
  const handleAssortmentWarehouseDetails = debounce(() => {
    setLoading(true);
    props.getDataFromAPI(
      `/partner/api/v1/assortment/cohort/${reference_id}/metadata`,
      "GET",
      undefined,
      (response) => {
        setAssortmentWarehouseMetaDataDetails(response || null);
        setLoading(false);
      },
      (err) => {
        console.error("API Error:", err);
        setLoading(false);
      }
    );
  }, 300);

  const handleAssortmentWarehouseDetailsList = debounce(() => {
    setLoading(true);
    props.getDataFromAPI(
      `/partner/api/v1/assortment/cohort/${reference_id}/all`,
      "GET",
      undefined,
      (response) => {
        setAssortmentWarehouseMetaDataDetailsList(response || { active: [], scheduled: [], inactive: [] });
        setLoading(false);
      },
      (err) => {
        console.error("API Error:", err);
        setLoading(false);
      }
    );
  }, 300);

  const handleAssortmentWarehouseRuleDetailsList = debounce(() => {
    setLoading(true);
    props.getDataFromAPI(
      `/partner/api/v1/assortment/rule/cohort/${reference_id}/all`,
      "GET",
      undefined,
      (response) => {
        setAssortmentWarehouseMetaDataRuleDetailsList(response || { active: [], scheduled: [], inactive: [] });
        setLoading(false);
      },
      (err) => {
        console.error("API Error:", err);
        setLoading(false);
      }
    );
  }, 300);

  const handleAssortmentCohortMachinesDetailsList = debounce(() => {
    setLoading(true);
    props.getDataFromAPI(
      `/partner/api/v1/assortment/cohort/${reference_id}/machine/details`,
      "GET",
      undefined,
      (response) => {
        const machinesData = response || [];
        setAssortmentCohortMachinesDetailsList(machinesData);
        if (machinesData.data && machinesData.data.length > 0) {
          setSelectedHardwareType(machinesData.data[0].hardwareTypeId);
        } else {
          setSelectedHardwareType(null);
        }
        setLoading(false);
      },
      (err) => {
        console.error("API Error:", err);
        setAssortmentCohortMachinesDetailsList({ data: [] });
        setSelectedHardwareType(null);
        setLoading(false);
      }
    );
  }, 300);

  const handleFetchWarehouses = debounce(() => {
    props.getDataFromAPI(
      '/partner/api/v2/warehouse/list',
      'GET',
      undefined,
      (response) => {
        setWarehouseList(response || []);
        setFilteredWarehouses(response || []);
      },
      (err) => {
        toastr.error('Failed', 'Unable to fetch warehouse listing');
      }
    );
  }, 300);

  const handleLinkWarehouse = () => {
    if (!selectedWarehouse) {
      toastr.error('Error', 'Please select a warehouse');
      return;
    }

    setLoading(true);
    props.getDataFromAPI(
      `/partner/api/v1/assortment/cohort/${reference_id}/warehouse/${selectedWarehouse}`,
      "POST",
      undefined,
      (response) => {
        toastr.success('Success', 'Warehouse linked successfully');
        setShowLinkWarehouseModal(false);
        setSelectedWarehouse(null);
        handleAssortmentWarehouseDetails(); // Refresh metadata
         handleAssortmentWarehouseDetailsList();
      handleAssortmentCohortMachinesDetailsList();
      handleAssortmentWarehouseRuleDetailsList();
        setLoading(false);
      },
      (err) => {
        console.error("API Error:", err);
        toastr.error('Error', 'Failed to link warehouse');
        setLoading(false);
      }
    );
  };

  const handleUnlinkWarehouse = () => {
    setShowUnlinkConfirmationModal(true);
  };

  const handleUnlinkConfirm = () => {
    setShowUnlinkConfirmationModal(false);
    setLoading(true);
    
    props.getDataFromAPI(
      `/partner/api/v1/assortment/warehouse/cohort/${reference_id}/unlink`,
      "DELETE",
      undefined,
      (response) => {
        setLoading(false);
        setShowUnlinkSuccessModal(true);
        handleAssortmentWarehouseDetails(); // Refresh metadata
         handleAssortmentWarehouseDetailsList();
      handleAssortmentCohortMachinesDetailsList();
      handleAssortmentWarehouseRuleDetailsList();
      },
      (err) => {
        console.error("API Error:", err);
        toastr.error('Error', 'Failed to unlink warehouse');
        setLoading(false);
      }
    );
  };

  const handleUnlinkSuccessOk = () => {
    setShowUnlinkSuccessModal(false);
  };

  const handleWarehouseSearch = (query) => {
    setWarehouseSearchTerm(query);
    const lowerCaseQuery = query.toLowerCase();
    const filtered = warehouseList.filter(
      (item) =>
        item.warehouseName?.toLowerCase().includes(lowerCaseQuery) ||
        item.warehouseId?.toString().includes(query)
    );
    setFilteredWarehouses(filtered);
  };

  // Initial data load
  useEffect(() => {
    if (reference_id) {
      handleAssortmentWarehouseDetails();
      handleAssortmentWarehouseDetailsList();
      handleAssortmentCohortMachinesDetailsList();
      handleAssortmentWarehouseRuleDetailsList();
    }
  }, [reference_id]);

  // Modal handlers
  const handleOpenEndRuleModal = (ruleId) => {
    setSelectedRuleToEnd(ruleId);
    setShowEndRuleModal(true);
  };

  const handleCloseEndRuleModal = () => {
    setShowEndRuleModal(false);
    setSelectedRuleToEnd(null);
    setEndDate("");
  };

  const handleEndRuleConfirm = () => {
    if (!endDate) {
      toastr.error('Error', 'End date is required');
      return;
    }

    setLoading(true);
    props.getDataFromAPI(
      `/partner/api/v1/assortment/rule/inactive/${selectedRuleToEnd}/${endDate}`,
      "PUT",
      undefined,
      (response) => {
        toastr.success('Success', 'Rule ended successfully');
        handleCloseEndRuleModal();
        handleAssortmentWarehouseRuleDetailsList();
         handleAssortmentWarehouseDetailsList();
        setLoading(false);
      },
      (err) => {
        console.error("API Error:", err);
        toastr.error('Error', 'Failed to end rule');
        setLoading(false);
      }
    );
  };

  const handleOpenLinkWarehouseModal = () => {
    handleFetchWarehouses();
    setShowLinkWarehouseModal(true);
  };

  const handleCloseLinkWarehouseModal = () => {
    setShowLinkWarehouseModal(false);
    setSelectedWarehouse(null);
    setWarehouseSearchTerm("");
    setFilteredWarehouses([]);
  };

  const handleCloseUnlinkConfirmationModal = () => {
    setShowUnlinkConfirmationModal(false);
  };

  // Navigation handlers
  const handleAssortmentDetails = (assortmentId) => {
    navigate(`/home/assortment/assortmentdetails/${assortmentId}`);
  };

  const handleCreateNewAssortment = () => {
    navigate(`/home/assortment/newassortmentcohortcreation/${reference_id}`);
  };

  const handleCreateNewRule = () => {
    navigate(`/home/assortment/newcohortassortmentrulecreation/${reference_id}`);
  };

  const handleRuleUpdate = (ruleId) => {
    navigate(`/home/assortment/cohort/rule/edit/${ruleId}`);
  };

  const handleCreateNewMachine = () => {
    navigate("/home/assortment/newmachinecreation");
  };

  return (
    <CohortAssortmentCreationComponent
      loading={loading}
      assortmentWarehouseMetaDataDetails={assortmentWarehouseMetaDataDetails}
      assortmentWarehouseMetaDataDetailsList={assortmentWarehouseMetaDataDetailsList}
      assortmentWarehouseMetaDataRuleDetailsList={assortmentWarehouseMetaDataRuleDetailsList}
      assortmentCohortMachinesDetailsList={assortmentCohortMachinesDetailsList}
      selectedHardwareType={selectedHardwareType}
      setSelectedHardwareType={setSelectedHardwareType}
      showEndRuleModal={showEndRuleModal}
      showLinkWarehouseModal={showLinkWarehouseModal}
      showUnlinkConfirmationModal={showUnlinkConfirmationModal}
      showUnlinkSuccessModal={showUnlinkSuccessModal}
      endDate={endDate}
      onEndDateChange={setEndDate}
      onCloseEndRuleModal={handleCloseEndRuleModal}
      onEndRuleConfirm={handleEndRuleConfirm}
      onAssortmentDetails={handleAssortmentDetails}
      onAssortmentRuleRemove={handleOpenEndRuleModal}
      onCreateNewAssortment={handleCreateNewAssortment}
      onCreateNewRule={handleCreateNewRule}
      onCreateNewMachine={handleCreateNewMachine}
      handleRuleUpdate={handleRuleUpdate}
      onTabChange={setActiveTab}
      onLinkWarehouse={handleOpenLinkWarehouseModal}
      onUnlinkWarehouse={handleUnlinkWarehouse}
      onUnlinkConfirm={handleUnlinkConfirm}
      onUnlinkSuccessOk={handleUnlinkSuccessOk}
      onCloseLinkWarehouseModal={handleCloseLinkWarehouseModal}
      onCloseUnlinkConfirmationModal={handleCloseUnlinkConfirmationModal}
      onLinkWarehouseConfirm={handleLinkWarehouse}
      warehouseList={filteredWarehouses}
      selectedWarehouse={selectedWarehouse}
      setSelectedWarehouse={setSelectedWarehouse}
      onWarehouseSearch={handleWarehouseSearch}
      warehouseSearchTerm={warehouseSearchTerm}
    />
  );
};

function mapStateToProps(state) {
  return { state };
}

export default connect(mapStateToProps, { getDataFromAPI })(CohortAssortmentListDetailsContainer);